import { render, staticRenderFns } from "./AbschnittKontakt.vue?vue&type=template&id=63e90822&"
import script from "./AbschnittKontakt.vue?vue&type=script&lang=js&"
export * from "./AbschnittKontakt.vue?vue&type=script&lang=js&"
import style0 from "./AbschnittKontakt.vue?vue&type=style&index=0&id=63e90822&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports